<template>
    <div>
        <template v-if="asientos.length != 0">
            <label>{{ $t('nuevo_abono.tus_asientos') }}</label>
            <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
                <div v-for="(asiento, index) in asientos" class="lightgray-content p-2 mb-2" :key="index">
                    <div class="text-bold mb-2 d-md-flex">
                        <div class="oswald">
                            {{ $t('general.abono', {abono: teatro.texto_abono}) }} {{ ++index }}. 
                            <span v-if="asiento.asiento && asiento.asiento.zona_nombre">{{ asiento.asiento.zona_nombre }}</span>
                        </div>
                        <div class="ml-2" v-if="asiento.asiento && typeof asiento.asiento === 'object'">
                            <small v-if="asiento.asiento.fila">{{ $t('general.fila') }}: {{ asiento.asiento.fila }} /</small> 
                            <small v-if="asiento.asiento.asiento">{{ $t('general.butaca') }}: {{ asiento.asiento.asiento }}</small>
                            <small v-if="asiento.asiento.visibilidad_reducida" class="text-danger">
                                - {{ $t('visibilidad_reducida.nombre') }}
                            </small>
                            <small v-if="asiento.asiento.porcentaje_visibilidad" class="text-danger">
                                : {{ asiento.porcentaje_visibilidad }}%
                            </small>
                        </div>
                    </div>
                </div>
                <div v-if="AsientosValidos == undefined  || AsientosValidos">
                    <button class="button effect-button large-button mb-4 mb-lg-5"  @click.prevent="continuar" type="submit" v-if="configuracion_valida && can_click"><span>{{ $t('nuevo_abono.continuar_compra') }}</span></button>
                </div>
                <h3 v-else>No puedes dejar un hueco entre dos asientos</h3>
                
                
                <div v-if="!configuracion_valida" class="alert alert-warning">
                    {{ $t('nuevo_abono.no_huecos') }}
                </div>
            </ValidationObserver>
        </template>
    </div>
</template>

<script>
    export default {
        props: ['asientos', 'configuracion_valida', 'can_click', 'AsientosValidos'],
        computed: {
            teatro() {
                return this.$store.getters.getTeatro
            }
        },
        methods: {
            continuar() {
                this.$emit('continuar', this.asientos);
            }
        },
    }
</script>
